import React, { useState } from "react";
import { P_Props } from "./VideoHomePageList.type";
import { VideoForm } from "../../..";
import { FloatingButton, Loading, Notification, Pulse } from "../../../../components";
import { CustomButton } from "../../../../components";
import { DeleteIcon } from "../../../../icons";
import InfiniteScroll from "react-infinite-scroller";
import { Dialog, InputAdornment, TextField, Grid, FormControlLabel, Switch } from "@material-ui/core";
import { PriorityHigh as PriorityHighIcon, Search } from "@material-ui/icons";
import { VideoStatus, BannerOutputModel, VIDEO_MODE } from "../../../../../models";
import { VideoUploadUtil } from "../../../../../utils";

const VideoHomePageListPresenter: React.FC<P_Props> = (props) => {
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);
  const [bannerDelete, setBannerDelete] = useState<BannerOutputModel | undefined>();

  const toggleDeleteModal = (banner) => {
    if (banner) {
      setBannerDelete(banner);
    }
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  return (
    <>
      <div className="video-listing">
        <div className="video-listing__content">
          <div className="video-listing__content__header">
            <div className="video-listing__content__header__title">All Videos</div>
            <div className="video-listing__content__header__actions">
              <div className="video-listing__content__header__actions--search">
                <TextField
                  placeholder="Search by name"
                  variant="outlined"
                  className="search-input"
                  inputProps={{ className: "input" }}
                  InputProps={{
                    // style: { fontSize: "1.4rem" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search className="icon" />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    props.onSearch(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="video-listing__content__list">
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedAllVideo.loading && props.fetchedAllVideo.totalPages > props.fetchedAllVideo.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedAllVideo.data.length) && props.fetchedAllVideo.loading && <Loading />}
              <Grid container spacing={8} style={{ width: "100%" }}>
                {props.fetchedAllVideo.data.map((video) => {
                  return (
                    <Grid item xs={3} key={video.id}>
                      <div className="video-listing__content__list__item">
                        <div className="video-listing__content__list__thumbnail">
                          {video.video ? (
                            <video width="100%" height="264" controls>
                              <source src={VideoUploadUtil.buildVideoSrc(video.video)} type="video/mp4" />
                              <source src={VideoUploadUtil.buildVideoSrc(video.video)} type="video/ogg" />
                              <source src={VideoUploadUtil.buildVideoSrc(video.video)} type="video/webm" />
                              Your browser does not support the video tag.
                            </video>
                          ) : (
                            <div className="video-text">
                              <iframe
                                width="100%"
                                height="264"
                                title="Video upload"
                                src={video.linkVideo?.replace("youtu.be/", "youtube.com/embed/")}
                              ></iframe>
                            </div>
                          )}
                        </div>
                        <div className="video-text video-listing__content__list__status">
                          <FormControlLabel
                            control={
                              <Switch
                                checked={Boolean(video.status === VideoStatus.PUBLISH)}
                                className="app-switch-box"
                                onChange={(e) => {
                                  e.preventDefault();
                                  props.handleChangeStatus(video.code, video.status);
                                }}
                              />
                            }
                            label={
                              <div className="video-text">
                                {Boolean(video.status === VideoStatus.PUBLISH) ? "Published" : "Not Publish"}
                              </div>
                            }
                          />
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <div
                            className="video-text video-listing__content__list__name"
                            onClick={() => props.openVideoFormModal(video.code)}
                          >
                            <b>{video.title}</b>
                          </div>
                          <div className="video-text video-listing__content__list__actions">
                            <CustomButton
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                toggleDeleteModal(video);
                              }}
                              color={"transparent"}
                              item={
                                <span>
                                  <DeleteIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                                </span>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
              {/* {Boolean(props.fetchedAllVideo.data.length) && props.fetchedAllVideo.loading && <Loading />} */}
            </InfiniteScroll>
          </div>
        </div>
      </div>

      <FloatingButton
        visible={props.visibleVideoForm}
        onClickPrimary={() => {
          props.openVideoFormModal();
        }}
        btns={[]}
      />

      <Dialog open={props.visibleVideoForm} maxWidth="lg" fullWidth>
        <VideoForm
          type={VIDEO_MODE.HOMEPAGE}
          // languageId={props.visibleSolutionId}
          videoCode={props.visibleVideoCode}
          onCancel={() => {
            props.closeVideoFormModal();
          }}
          onComplete_Create={() => {
            props.closeVideoFormModal();
            props.reloadListingPage();
          }}
          onComplete_Update={() => {
            props.closeVideoFormModal();
            props.reloadListingPage();
          }}
          onComplete_Delete={() => {
            props.closeVideoFormModal();
            props.reloadListingPage();
          }}
        />
      </Dialog>

      {/* Delete warning modal */}
      <Notification
        visible={visibleDeleteModal}
        title="Delete Video"
        subTitle={`Are you sure you want to delete video “${bannerDelete?.title}“? This action cannot be undone.`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="video-listing__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal(bannerDelete);
              }}
            >
              Cancel
            </button>
            <button
              className="video-listing__delete-modal__actions__confirm"
              onClick={async () => {
                toggleDeleteModal(bannerDelete);
                if (bannerDelete?.code) {
                  await props.onDeleteVideo(bannerDelete.code);
                }
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default VideoHomePageListPresenter;
